import { Injectable } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { DataEntriesControllerService, DataEntry } from '@osos/shared/api';
import { DataTypeEnum, ManagedHttpContext, Where } from '@osos/shared/types';
import { Observable } from 'rxjs';
import { ApiUtilsService } from '../../api-utils/api-utils.service';

@Injectable()
export class EntryDataService extends DataEntriesControllerService {
  constructor(private apiHelper: ApiUtilsService) {
    super();
  }

  checkEntryFieldValueUniqueness(
    entityId: string,
    entryId: string,
    fieldNormalizedName: string,
    value: any,
    type: DataTypeEnum,
  ): Observable<ValidationErrors> {
    const _idCond = entryId ? { id: { neq: entryId } } : {};
    let where: Where<DataEntry>;
    if (type === DataTypeEnum.LocalizedJson) {
      where = this.apiHelper.prepareLocalPropFilter({
        name: value,
        id: entryId,
        propFilter: `value.${fieldNormalizedName}`,
      });
    } else if (type === DataTypeEnum.Entity) {
      where = {
        ..._idCond,
        and: [
          {
            [`value.${fieldNormalizedName}.dataEntry`]: { eq: value.dataEntry },
          },
        ],
      };
    } else {
      where = {
        ..._idCond,
        and: [{ [`value.${fieldNormalizedName}`]: { eq: value } }],
      };
    }
    where = {
      ...where,
      state: 1,
    };
    return this.count({
      entity: entityId,
      where: this.apiHelper.prepareWhere<DataEntry | any>(where),
    });
  }

  isEntryFieldEditable({
    entity,
    id,
    fieldId,
    viewId,
  }: {
    entity: string;
    id: string;
    fieldId: string;
    viewId?: string;
  }): Observable<{ hidden: boolean; locked: boolean; required: boolean }> {
    return this.isFieldEditable({
      entity,
      id,
      fieldId,
      context: viewId
        ? new ManagedHttpContext({ publicAccessId: viewId })
        : undefined,
    });
  }
}
